import { render } from "./VideoGroup.vue?vue&type=template&id=69a154ff&scoped=true"
import script from "./VideoGroup.vue?vue&type=script&lang=js"
export * from "./VideoGroup.vue?vue&type=script&lang=js"

import "./VideoGroup.vue?vue&type=style&index=0&id=69a154ff&lang=less&scoped=true"

import exportComponent from "C:\\Users\\sander\\IdeaProjects\\matchmaking\\fbm-matchmaking\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a154ff"]])

export default __exports__